import { useMemo } from "react";
import _ from "lodash";

import Box from "components/Box";
import SanitizeHtml from "components/SanitizeHtml";
import Stack from "components/Stack";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";
import { useAITableDisplayMode } from "entities/Memo/utils";

interface IPrintableSectionAISummaryResponse {
  section: IMemoSection;
  dealId: number;
  externalToken?: string;
}

const PrintableSectionAISummaryResponse = ({
  section,
  dealId,
  externalToken,
}: IPrintableSectionAISummaryResponse) => {
  const openai_custom_prompt_response = useMemo(
    () => _.first(section.memo_section_openai_responses),
    [section]
  );

  const { sanitizeHtmlOptions, sanitizeHtmlContainerStyles } =
    useAITableDisplayMode({
      dealId,
      externalToken,
    });

  return (
    <Box>
      <SectionHeader label={section.title} alignActionButton="right" />
      <SectionContent>
        {!section?.is_na && (
          <Stack
            spacing={2}
            sx={{
              "*": { lineHeight: "140% !important" },
              table: {
                width: "100%",
              },
              "table, th, td, tr": {
                borderCollapse: "collapse",
                border: "1px solid black !important",
              },
              ...sanitizeHtmlContainerStyles,
            }}
          >
            {!_.isNil(openai_custom_prompt_response) && (
              <SanitizeHtml
                html={openai_custom_prompt_response.response}
                options={sanitizeHtmlOptions}
              />
            )}
          </Stack>
        )}
      </SectionContent>
    </Box>
  );
};

export default PrintableSectionAISummaryResponse;
